"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var graphql_tag_1 = require("graphql-tag");
var react_apollo_1 = require("react-apollo");
var lodash_1 = require("lodash");
function renderCategories(categories) {
    if (!categories) {
        return null;
    }
    return categories.map(function (category) { return React.createElement("h3", { key: category }, category); });
}
exports.SellCSPPreview = function (props) {
    return (lodash_1.get(props.data, 'csp') ? (React.createElement("section", { className: "sell-preview" },
        React.createElement("div", { className: "sell-preview__container" },
            React.createElement("div", { className: "sell-preview__image" },
                React.createElement("img", { src: props.data.csp.image.source, alt: props.data.csp.title })),
            React.createElement("div", { className: "sell-preview__info" },
                React.createElement("div", { className: "sell-preview__header" },
                    React.createElement("div", { className: "sell-preview__make-model" },
                        React.createElement("h1", null, props.make),
                        React.createElement("h2", null, props.model)),
                    React.createElement("button", { type: "button", className: "sell-preview__edit", onClick: function () { return props.editForm(); } }, I18n.t('discovery.SellCSPPreview.edit'))),
                React.createElement("div", { className: "sell-preview__attributes" },
                    props.year && React.createElement("h3", null, props.year),
                    props.finish && React.createElement("h3", null, props.finish),
                    props.countryOfOrigin && React.createElement("h3", null, I18n.t("countries." + props.countryOfOrigin)),
                    renderCategories(props.categories)))))) : null);
};
var connect = react_apollo_1.graphql(graphql_tag_1.default(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n    query Core_SellFlow_CSP($id: String) {\n      csp(input: { id: $id }) {\n        title\n        image(input: { transform: \"card_square\" }) {\n          source\n        }\n      }\n    }\n  "], ["\n    query Core_SellFlow_CSP($id: String) {\n      csp(input: { id: $id }) {\n        title\n        image(input: { transform: \"card_square\" }) {\n          source\n        }\n      }\n    }\n  "]))), {
    skip: function (_a) {
        var cspId = _a.cspId;
        return !cspId;
    },
    options: function (_a) {
        var cspId = _a.cspId;
        return ({
            ssr: false,
            variables: {
                id: cspId,
            },
        });
    },
});
exports.default = connect(function (props) { return exports.SellCSPPreview(tslib_1.__assign({}, props)); });
var templateObject_1;
//# sourceMappingURL=sell_csp_preview.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/sell/sell_csp_preview.js
// module id = FD1Z
// module chunks = 20 21